module.exports = __webpack_public_path__ + "img/Carl_Cook.b85a80a3.png";